<template>
  <!-- 信标新增/编辑表单 -->
  <a-modal
    :title="formTitle || '新增信标'"
    v-model:visible="open"
    @cancel="onClose"
    :width="800"
    :maskClosable="false"
    :keyboard="false"
    :destroyOnClose="true"
    :footer="null"
    class="create-form-modal"
  >
    <!-- 表单内容 -->
    <a-form
      ref="form"
      :model="form"
      :rules="rules"
      :label-col="{ flex: '0 0 150px' }"
      :wrapper-col="{ flex: '1 1 auto' }"
      class="two-column-form"
    >
      <a-row :gutter="12">
        <a-col :span="12">
          <!-- 信标MAC（必填） -->
          <a-form-item label="信标MAC" name="mac">
            <a-input v-model:value="form.mac" placeholder="请输入信标MAC" />
          </a-form-item>
        </a-col>
        <a-col :span="12">
          <!-- 设备码 -->
          <a-form-item label="设备码" name="deviceCode">
            <a-input v-model:value="form.deviceCode" placeholder="请输入设备码" />
          </a-form-item>
        </a-col>
      </a-row>

      <a-row :gutter="12">
        <a-col :span="12">
          <!-- Major（必填） -->
          <a-form-item label="Major" name="major">
            <a-input v-model:value="form.major" placeholder="请输入Major" />
          </a-form-item>
        </a-col>
        <a-col :span="12">
          <!-- Minor（必填） -->
          <a-form-item label="Minor" name="minor">
            <a-input v-model:value="form.minor" placeholder="请输入Minor" />
          </a-form-item>
        </a-col>
      </a-row>

      <a-row :gutter="12">
        <a-col :span="12">
          <!-- 信标状态（字典值） -->
          <a-form-item label="信标状态" name="beaconStatus">
            <a-select
              v-model:value="form.beaconStatus"
              placeholder="请选择信标状态"
              allow-clear
            >
              <a-select-option
                v-for="(d, index) in dict.type['beacon_status']"
                :key="d.value"
                :value="d.value"
                >{{ d.label }}</a-select-option
              >
            </a-select>
          </a-form-item>
        </a-col>
        <a-col :span="12">
          <!-- 所属空间 -->
          <a-form-item label="所属空间" name="spaceId">
            <a-select
              v-model:value="form.spaceId"
              placeholder="请选择所属空间"
              show-search
              :filter-option="filterSpaceOption"
              allow-clear
              style="width: 100%"
            >
              <a-select-option
                v-for="space in spaceList"
                :key="space.id"
                :value="space.id"
              >
                {{ space.name }}
              </a-select-option>
            </a-select>
          </a-form-item>
        </a-col>
      </a-row>

      <a-row :gutter="12">
        <a-col :span="12">
          <!-- 启用时间 -->
          <a-form-item label="启用时间" name="activationTime">
            <a-date-picker
              style="width: 100%"
              v-model:value="form.activationTime"
              format="YYYY-MM-DD HH:mm:ss"
              valueFormat="YYYY-MM-DD HH:mm:ss"
              :show-time="{ format: 'HH:mm:ss' }"
              placeholder="请选择启用时间"
              allow-clear
            />
          </a-form-item>
        </a-col>
        <a-col :span="12">
          <!-- 最新状态时间 -->
          <a-form-item label="最新状态时间" name="beaconTime">
            <a-date-picker
              style="width: 100%"
              v-model:value="form.beaconTime"
              :show-time="{ format: 'HH:mm:ss' }"
              format="YYYY-MM-DD HH:mm:ss"
              valueFormat="YYYY-MM-DD HH:mm:ss"
              placeholder="请选择最新状态时间"
              allow-clear
            />
          </a-form-item>
        </a-col>
      </a-row>

      <a-row :gutter="12">
        <a-col :span="12">
          <!-- 电池更换时间 -->
          <a-form-item label="电池更换时间" name="batteryReplacement">
            <a-date-picker
              style="width: 100%"
              v-model:value="form.batteryReplacement"
              format="YYYY-MM-DD HH:mm:ss"
              valueFormat="YYYY-MM-DD HH:mm:ss"
              :show-time="{ format: 'HH:mm:ss' }"
              placeholder="请选择电池更换时间"
              allow-clear
            />
          </a-form-item>
        </a-col>
        <a-col :span="12">
          <!-- 采购时间 -->
          <a-form-item label="采购时间" name="purchaseTime">
            <a-date-picker
              style="width: 100%"
              v-model:value="form.purchaseTime"
              format="YYYY-MM-DD HH:mm:ss"
              :show-time="{ format: 'HH:mm:ss' }"
              valueFormat="YYYY-MM-DD HH:mm:ss"
              placeholder="请选择采购时间"
              allow-clear
            />
          </a-form-item>
        </a-col>
      </a-row>

      <a-row :gutter="12">
        <a-col :span="12">
          <!-- 空间时间（绑定空间时间） -->
          <a-form-item label="空间时间" name="bindTime">
            <a-date-picker
              style="width: 100%"
              v-model:value="form.bindTime"
              format="YYYY-MM-DD HH:mm:ss"
              :show-time="{ format: 'HH:mm:ss' }"
              valueFormat="YYYY-MM-DD HH:mm:ss"
              placeholder="请选择空间时间"
              allow-clear
            />
          </a-form-item>
        </a-col>
        <a-col :span="12">
          <!-- 续航时间(天) -->
          <a-form-item label="续航时间(天)" name="batteryLife">
            <a-input-number
              v-model:value="form.batteryLife"
              :min="0"
              :step="0.1"
              style="width: 100%"
              placeholder="请输入续航时间(天)"
            />
          </a-form-item>
        </a-col>
      </a-row>

      <a-row :gutter="12">
        <a-col :span="12">
          <!-- 生产厂家 -->
          <a-form-item label="生产厂家" name="manufacturer">
            <a-input
              v-model:value="form.manufacturer"
              placeholder="请输入生产厂家"
            />
          </a-form-item>
        </a-col>
        <a-col :span="12">
          <!-- 型号 -->
          <a-form-item label="型号" name="beaconModel">
            <a-input v-model:value="form.beaconModel" placeholder="请输入型号" />
          </a-form-item>
        </a-col>
      </a-row>

      <!-- 操作按钮 -->
      <div class="bottom-control">
        <a-space>
          <a-button @click="cancel" class="cancel-btn"> 取消 </a-button>
          <a-button type="primary" :loading="submitLoading" @click="submitForm" class="save-btn">
            保存
          </a-button>
        </a-space>
      </div>
    </a-form>
  </a-modal>
</template>

<script>
import { $on, $off, $once, $emit } from '../../../../utils/gogocodeTransfer'
import { getBeacon, addBeacon, updateBeacon } from '@/api/system/beacon'
import { listSpace } from '@/api/system/space'

export default {
  name: 'CreateForm',
  // 字典类型配置：信标状态
  dicts: ['beacon_status'],
  data() {
    return {
      // 提交按钮加载状态
      submitLoading: false,
      // 表单标题（添加/修改）
      formTitle: '',
      // 表单数据对象
      form: {
        id: null, // 信标ID
        projectId: null, // 项目ID
        mac: null, // 信标MAC地址（必填）
        activationTime: null, // 启用时间
        deviceCode: null, // 设备码
        batteryLife: null, // 续航时间(天)
        manufacturer: null, // 生产厂家
        batteryReplacement: null, // 电池更换时间
        beaconModel: null, // 型号
        beaconStatus: null, // 信标状态（字典值）
        major: null, // Major（必填）
        beaconTime: null, // 最新状态时间
        minor: null, // Minor（必填）
        spaceId: null, // 所属空间ID
        purchaseTime: null, // 采购时间
        bindTime: null, // 绑定空间时间
      },
      // 表单类型：1-新增，2-修改
      formType: 1,
      // 抽屉显示/隐藏状态
      open: false,
      // 空间列表
      spaceList: [],
      // 表单验证规则
      rules: {
        // 信标MAC验证规则：必填
        mac: [{ required: true, message: '信标MAC不能为空', trigger: 'blur' }],
        // Major验证规则：必填
        major: [{ required: true, message: 'Major不能为空', trigger: 'blur' }],
        // Minor验证规则：必填
        minor: [{ required: true, message: 'Minor不能为空', trigger: 'blur' }],
      },
    }
  },
  methods: {
    /**
     * 关闭抽屉
     */
    onClose() {
      this.open = false
      // 触发关闭事件，通知父组件刷新表格
      $emit(this, 'close')
    },

    /**
     * 取消按钮操作
     * 关闭抽屉并重置表单
     */
    cancel() {
      this.open = false
      this.reset()
      // 触发关闭事件，通知父组件刷新表格
      $emit(this, 'close')
    },

    /**
     * 表单重置
     * 将表单数据重置为初始状态
     */
    reset() {
      this.formType = 1
      this.form = {
        id: null,
        projectId: null,
        mac: null,
        activationTime: null,
        deviceCode: null,
        batteryLife: null,
        manufacturer: null,
        batteryReplacement: null,
        beaconModel: null,
        beaconStatus: null,
        major: null,
        beaconTime: null,
        minor: null,
        spaceId: null,
        purchaseTime: null,
        bindTime: null,
      }
    },

    /**
     * 新增按钮操作
     * 打开新增表单，需要先选择项目
     * @param {Object} row - 行数据（未使用）
     */
    handleAdd(row) {
      // 从 Vuex 获取当前项目ID
      const currentProjectId = this.$store.getters.currentProjectId
      if (!currentProjectId) {
        this.$message.warning('请先选择项目', 3)
        return
      }
      this.reset()
      this.formType = 1
      // 设置项目ID
      this.form.projectId = currentProjectId
      // 加载空间列表
      this.loadSpaceList(currentProjectId)
      this.open = true
      this.formTitle = '添加'
    },

    /**
     * 修改按钮操作
     * 根据ID获取信标数据并填充表单
     * @param {Object} row - 行数据对象
     * @param {Number|String} ids - 信标ID（当row为空时使用）
     */
    handleUpdate(row, ids) {
      this.reset()
      this.formType = 2
      const id = row ? (row.id || row.beaconId) : ids
      if (!id) {
        console.error('信标ID为空，row对象:', row)
        this.$message.error('信标ID不能为空', 3)
        return
      }
      // 获取信标详情
      getBeacon({ id: id })
        .then((response) => {
          if (response && response.data) {
            this.form = response.data
            // 加载空间列表（使用信标的项目ID）
            if (this.form.projectId) {
              this.loadSpaceList(this.form.projectId)
            } else {
              // 如果没有项目ID，从 Vuex 获取
              const currentProjectId = this.$store.getters.currentProjectId
              if (currentProjectId) {
                this.loadSpaceList(currentProjectId)
              }
            }
            this.open = true
            this.formTitle = '修改'
          } else {
            this.$message.error('获取信标详情失败', 3)
          }
        })
        .catch((error) => {
          console.error('获取信标详情失败:', error)
          this.$message.error('获取信标详情失败，请稍后重试', 3)
        })
    },

    /**
     * 加载空间列表
     * 根据项目ID查询空间列表
     * @param {Number|String} projectId - 项目ID
     */
    loadSpaceList(projectId) {
      if (!projectId) {
        this.spaceList = []
        return
      }
      listSpace({ projectId: projectId })
        .then((response) => {
          console.log(response)
          if (response.code == 20001) {
            this.spaceList = response.data || []
          } else {
            this.spaceList = []
          }
        })
        .catch(() => {
          this.spaceList = []
          this.$message.error('获取空间列表失败，请稍后重试')
        })
    },

    /**
     * 空间选择框搜索过滤
     * @param {String} input - 输入值
     * @param {Object} option - 选项对象
     * @returns {Boolean} 是否匹配
     */
    filterSpaceOption(input, option) {
      // 获取选项的值（空间ID）
      const spaceId =
        option.componentOptions &&
        option.componentOptions.propsData &&
        option.componentOptions.propsData.value
      if (spaceId) {
        // 从空间列表中找到对应的空间对象
        const space = this.spaceList.find((s) => s.id === spaceId)
        if (space && space.name) {
          // 根据空间名称进行模糊匹配（不区分大小写）
          return space.name.toLowerCase().indexOf(input.toLowerCase()) >= 0
        }
      }
      return false
    },

    /**
     * 提交表单
     * 根据表单类型（新增/修改）调用相应的API接口
     */
    submitForm() {
      // 表单验证
      this.$refs.form.validate().then(() => {
        this.submitLoading = true
        // 判断是修改还是新增
        if (this.form.id !== undefined && this.form.id !== null) {
          // 修改操作
          updateBeacon(this.form)
            .then((response) => {
              this.$message.success('修改成功', 3)
              this.open = false
              // 触发父组件刷新事件
              $emit(this, 'ok')
            })
            .finally(() => {
              this.submitLoading = false
            })
        } else {
          // 新增操作
          addBeacon(this.form)
            .then((response) => {
              this.$message.success('新增成功', 3)
              this.open = false
              // 触发父组件刷新事件
              $emit(this, 'ok')
            })
            .finally(() => {
              this.submitLoading = false
            })
        }
      }).catch(() => {
        // 验证失败
        return false
      })
    },
  },
  emits: ['ok', 'close'],
}
</script>

<style scoped>
/* 按钮样式 */
.save-btn {
  background-color: #165DFF !important;
  border-color: #165DFF !important;
  color: #FFFFFF !important;
  border-radius: 4px !important;
}

.save-btn:hover {
  background-color: #165DFF !important;
  border-color: #165DFF !important;
  color: #FFFFFF !important;
  opacity: 0.9;
}

.cancel-btn {
  background-color: #F3F3F3 !important;
  border-color: #F3F3F3 !important;
  color: #101010 !important;
  border-radius: 4px !important;
}

.cancel-btn:hover {
  background-color: #F3F3F3 !important;
  border-color: #F3F3F3 !important;
  color: #101010 !important;
}

.bottom-control {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  margin-top: 24px;
  padding-top: 16px;
  border-top: 1px solid #f0f0f0;
}
</style>

<style>
/* Modal body 样式 - 使用全局样式确保生效 */
.create-form-modal .ant-modal-body {
  padding: 20px 16px 90px 4px !important;
}

/* 表单左边距调整 - 使用全局样式 */
.create-form-modal .ant-form {
  margin-left: -24px !important;
  margin-right: 0 !important;
  padding-left: 0 !important;
  padding-right: 0 !important;
}
</style>

<style>
/* 输入框样式 - 圆角和边框 */
.create-form-modal .ant-input,
.create-form-modal .ant-input:hover,
.create-form-modal .ant-input:focus {
  border-radius: 4px !important;
  border: 1px solid #C7C7C7 !important;
}

.create-form-modal .ant-input-affix-wrapper,
.create-form-modal .ant-input-affix-wrapper:hover,
.create-form-modal .ant-input-affix-wrapper-focused {
  border-radius: 4px !important;
  border: 1px solid #C7C7C7 !important;
}

/* 带前缀/后缀的输入框内部input去掉边框，避免嵌套 */
.create-form-modal .ant-input-affix-wrapper .ant-input {
  border: none !important;
  background: transparent !important;
  box-shadow: none !important;
}

/* 选择框样式 */
.create-form-modal .ant-select-selector,
.create-form-modal .ant-select-selector:hover,
.create-form-modal .ant-select-focused .ant-select-selector {
  border-radius: 4px !important;
  border: 1px solid #C7C7C7 !important;
}

/* 日期选择器样式 */
.create-form-modal .ant-picker,
.create-form-modal .ant-picker:hover,
.create-form-modal .ant-picker-focused {
  border-radius: 4px !important;
  border: 1px solid #C7C7C7 !important;
}

/* 数字输入框样式 */
.create-form-modal .ant-input-number,
.create-form-modal .ant-input-number:hover,
.create-form-modal .ant-input-number-focused {
  border-radius: 4px !important;
  border: 1px solid #C7C7C7 !important;
}

/* 按钮保持圆角 */
.create-form-modal .ant-btn {
  border-radius: 4px !important;
}

/* 两列布局样式 */
.two-column-form :deep(.ant-form-item-control-wrapper) {
  flex: 1;
}

.two-column-form :deep(.ant-row) {
  flex-wrap: nowrap;
}

.two-column-form :deep(.ant-col-12) {
  width: 50%;
  max-width: 50%;
}

/* 减少列之间的间距 */
.two-column-form :deep(.ant-col-12:first-child) {
  padding-right: 6px !important;
}

.two-column-form :deep(.ant-col-12:last-child) {
  padding-left: 6px !important;
}

/* 减少整个表单的左边距 */
.two-column-form :deep(.ant-form-item) {
  margin-left: -8px !important;
  margin-right: -8px !important;
}

/* 调整标签对齐，确保不会过于靠右 */
.two-column-form :deep(.ant-form-item-label) {
  margin-right: -4px !important;
}
</style>
